import { calculateTimeLeftText, calculateTimelineText } from 'fitbeat.gym-core';
import { IUserLeaderboardViewModel } from 'fitbeat.models';
import React from 'react';
import {
  StyleSheet, Text, TouchableOpacity, View,
} from 'react-native';
import { TranslateProp } from '../common-types';
import Theme from '../theme';
import { defaultScale } from '../utils';

interface IProps {
  leaderboard: IUserLeaderboardViewModel;
  selectedTeam: string | null;
  selectTeam: (team: string) => void;
  t: TranslateProp;
}

export function JoinTeamScreen({
  leaderboard, selectedTeam, selectTeam, t,
}: IProps) {
  const timelineText = calculateTimeLeftText(leaderboard.startDate, leaderboard.endDate);

  return (
    <View style={styles.container}>
      <View style={styles.headerContainer}>
        <Text style={styles.header}>{leaderboard.name}</Text>
      </View>
      <View style={styles.subHeaderContainer}>
        <Text style={styles.subHeader}>
          <Text style={{ ...Theme.textStyle.bodyCopyBold }}>
            <Text style={{ ...Theme.textStyle.bodyCopyReg }}>
              {timelineText.isUpcoming ? 'Starts in' : 'Ends in'}
              {' '}
            </Text>
            {timelineText.unit}
            {' '}
            {timelineText.timeUnit}
          </Text>
        </Text>
        <View style={styles.horizontalDivider} />
        <Text style={{ ...Theme.textStyle.bodyCopyReg }}>
          {calculateTimelineText(leaderboard.startDate, leaderboard.endDate, leaderboard.timezone, false)}
        </Text>
      </View>
      <View style={styles.verticalDivider} />
      <View>
        <Text style={styles.selectTeamText}>{t('dashboard:selectTeam')}</Text>

        {leaderboard.teams?.map((team: string) => {
          const isActive = selectedTeam === team;
          return (
            <TouchableOpacity
              onPress={() => selectTeam(team)}
              style={[
                styles.teamContainer,
                { backgroundColor: isActive ? Theme.BLACK : Theme.WHITE },
              ]}
            >
              <Text style={{
                ...Theme.textStyle.bodyCopyBold,
                color: isActive ? Theme.WHITE : Theme.BLACK,
              }}
              >
                {team}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  horizontalDivider: {
    borderLeftWidth: 1,
    borderLeftColor: Theme.GREY_LIGHT,
  },
  verticalDivider: {
    borderWidth: 1,
    borderColor: Theme.GREY_LIGHT,
  },
  header: {
    ...Theme.textStyle.heading,
    marginRight: defaultScale(30),
  },
  subHeaderContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: defaultScale(20),
    marginBottom: defaultScale(20),
  },
  subHeader: {
    ...Theme.textStyle.bodyCopyReg,
    flex: 0.5,
  },
  selectTeamText: {
    ...Theme.textStyle.bodyCopyBold,
    marginTop: defaultScale(20),
    marginBottom: defaultScale(5),
  },
  headerContainer: {
  },
  teamContainer: {
    borderWidth: defaultScale(0.3),
    borderRadius: defaultScale(3),
    borderColor: Theme.GREY_DARK,
    height: defaultScale(55),
    marginVertical: defaultScale(8),
    justifyContent: 'center',
    alignItems: 'center',
  },
  textContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  container: {
    padding: defaultScale(18),
    backgroundColor: Theme.WHITE,
  },
});
